export default __webpack_public_path__ + "static/foundations-carousel-panel2-bf62c8aced818cc652e81d7b60c20961c4d8e1acfacc939a8888b0dc0491a130.png";